import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { NotificationDto } from '@app/data/dtos/notification/notification.dto';
import { mapDataNotification } from '@app/data/mappers/notification/notification.mapper';
import { NotificationRepository } from '@app/domain/repositories/notification.repository.contract';
import { NotificationStatus } from '@app/entities/enums/notification/notification.enum';
import { ErrorCodes, ErrorMessages } from '@app/entities/models/error/error.model';
import { Notification } from '@app/entities/models/notifications/notification.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';
import { Logger } from '@services/logger/logger.service';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({ providedIn: 'root' })
export class NotificationRepositoryImpl extends MRepository implements NotificationRepository {
  readonly logger: Logger = new Logger('NotificationService');
  private sectionMaintenance = false;

  constructor() {
    super(`${ENV.API_URL_NOTIFICATIONS}`);
  }

  fetchNotifications(lang: string): Observable<Notification[]> {
    return this.get<NotificationDto[]>(`/notification`, { params: { lang } }).pipe(
      map(mapDataNotification),
      catchError(this.handleError)
    ) as Observable<Notification[]>;
  }

  checkAsReadNotification(notification: Notification): Observable<void> {
    const request = {
      body: {
        status: NotificationStatus.OPENED
      }
    };
    return this.put(`/notification/${notification.id}`, request);
  }

  getSectionMaintenance() {
    return this.sectionMaintenance;
  }

  private setSectionMaintenance(maintenance: boolean) {
    this.sectionMaintenance = maintenance;
  }

  private handleError = (error: HttpErrorResponse): Observable<MSafeAny[]> => {
    this.setSectionMaintenance(
      error.status === ErrorCodes.SECTION_MAINTENANCE && error.error.code === ErrorMessages.PERM_DEACTIVATED
    );
    this.logger.error(error);

    return of([]);
  };
}
